/* eslint-disable no-useless-escape */

import { I18n } from './helpers/i18n.mjs';
import { IML } from './deps/iml.mjs';
import FormanConfig from './formanConfig.mjs';

export function escapeHtml(value) {
	return String(value)
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

export function markdown(data) {
	const codes = [];

	return escapeHtml(data)
		.replace(/\{\{l:([^@]+)@([^\}]+)\}\}/g, (a, b, c) => I18n.l(b, { ns: c }))
		.replace(/\[([^\]]*)\]\(([^\)]*)\)/g, (a, b, c) => {
			// to prevent JS injection, don't create link from markdown in following case:
			if (c?.startsWith('javascript:')) {
				return `${a}`;
			}

			if (/^kb:\/\/(.*)$/i.test(c)) {
				const path = RegExp.$1;

				c = IML.execute(IML.parse(FormanConfig.config.kb.path), {
					path,
				});
				return `<a target=\"_blank\" class=\"i-open-help\" href=\"${c}\">${b}</a>`;
			} else {
				return `<a target=\"_blank\" href=\"${c}\">${b}</a>`;
			}
		})
		.replace(/`([^`]+)`/g, (a, b) => {
			codes.push(`<code>${b}</code>`);
			return `{{code:${codes.length - 1}}}`;
		})
		.replace(/(^|\W)__([^_]+)__(\W|$)/g, (a, pr, b, po) => `${pr}<strong>${b}</strong>${po}`)
		.replace(/(^|\W)_([^_]+)_(\W|$)/g, (a, pr, b, po) => `${pr}<em>${b}</em>${po}`)
		.replace(/(^|\W)\*\*([^*]+)\*\*(\W|$)/g, (a, pr, b, po) => `${pr}<strong>${b}</strong>${po}`)
		.replace(/(^|\W)\*([^*]+)\*(\W|$)/g, (a, pr, b, po) => `${pr}<em>${b}</em>${po}`)
		.replace(/\n/g, (a, b) => '<br>')
		.replace(/\{\{code:(\d+)\}\}/g, (a, b) => codes[b]);
}
